import LoadingIndicator from "@components/LoadingIndicator";
import ReservationFrameItem from "@components/ReservationFrameItem";
import type {
  ReservationFrameItem_PointsToGiveFrameFragment,
  ReservationFrameItem_ReservationFrameFragment,
} from "@components/ReservationFrameItem/__generated__/fragments";
import { ReservationPointModal } from "@components/ReservationPointModal";
import { ReservationFormRow } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormRow";
import useIsPcByUA from "@hooks/useIsPcByUA";
import { useModalDialog } from "@hooks/useModalDialog";
import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  loading: boolean;
  frames: ReservationFrameItem_ReservationFrameFragment[];
  pointsToGiveFrames: ReservationFrameItem_PointsToGiveFrameFragment[];
  launchTelModal: () => void;
  canUseOnSystemPayment: boolean;
  cancelFeePercentage: number | undefined;
};
export const ReservationFormPlanRow: FC<Props> = ({
  loading,
  frames,
  pointsToGiveFrames,
  launchTelModal,
  canUseOnSystemPayment,
  cancelFeePercentage,
}) => {
  const { isPcByUA } = useIsPcByUA.useContainer();
  const pointModal = useModalDialog();
  return (
    <ReservationFormRow title="ご予約プラン">
      <div className={styles.planCardList}>
        {loading ? (
          <div className={styles.planCardUnavailable}>
            <LoadingIndicator />
          </div>
        ) : frames.length > 0 ? (
          frames.map((frame) => (
            <ReservationFrameItem
              key={frame.id}
              frame={frame}
              pointsToGiveFrame={pointsToGiveFrames.find(
                (p) => p.reservationFrameId === frame.id
              )}
              onTelStateItemClick={() => !isPcByUA && launchTelModal()}
              cancelFeePercentage={cancelFeePercentage}
            />
          ))
        ) : (
          <div className={styles.planCardUnavailable}>
            ご利用可能なプランがありません
          </div>
        )}
      </div>
      <div className={styles.pointsBreakdown}>
        <button type="button" onClick={pointModal.show}>
          獲得ポイントの内訳
        </button>
      </div>
      <ReservationPointModal
        isShown={pointModal.isShown}
        onClose={pointModal.abortHandler}
        hasCloseButton
        onCloseButtonClick={pointModal.abortHandler}
        descriptionType={
          canUseOnSystemPayment ? "priceBased" : "personNumBased"
        }
      />
    </ReservationFormRow>
  );
};
